import React from "react";
import { connect } from "react-redux";
import { IRootState } from "reducers";
import spinnerImg from "./image/Double.svg";

const Spinner: React.FC<{ isUIBlocked: boolean }> = ({ isUIBlocked }) => (
  <React.Fragment>
    {isUIBlocked && (
      <>
      <div className="lds-css ng-scope"><div style={{width:'100%',height:'100%'}} className="lds-double-ring"><div></div><div></div></div></div>
      <div className="modal-backdrop spiner-background" />
      </>
    )}
  </React.Fragment>
);

const mapStateToProps = ({ app: { isUIBlocked } }: IRootState) => ({
  isUIBlocked
});

export default connect(mapStateToProps)(Spinner);
